module.exports = __webpack_public_path__ + "static/media/show-shadow_01.4d1737ee.svg";